import type { ReactNode } from 'react';
import { CapturePredefinedGoalStep } from './predefined-goal-details/CapturePredefinedGoalStep';
import { SelectGoalStep } from './select-goal/SelectGoalStep';
import { useGoalsAndInterventionsWizard } from './GoalsAndInterventionsWizardContext';
import { CaptureInterventionDetailsStep } from './capture-intervention-details/CaptureInterventionDetailsStep';
import { SelectInterventionsStep } from './selecting-interventions/SelectInterventionsStep';

export function WizardSteps() {
	const { wizardState } = useGoalsAndInterventionsWizard();

	let visibleStep: string;
	let step: ReactNode;
	if (wizardState.currentStep === 'SELECT_GOAL' || wizardState.currentStep === 'LOAD_GOAL_DEFINITION') {
		visibleStep = 'SELECT_GOAL';
		step = <SelectGoalStep />;
	} else if (wizardState.currentStep === 'CAPTURE_GOAL_DETAILS') {
		visibleStep = 'CAPTURE_GOAL_DETAILS';
		step = <CapturePredefinedGoalStep />;
	} else if (wizardState.currentStep === 'SELECTING_INTERVENTIONS' || wizardState.currentStep === 'LOAD_INTERVENTION_DEFINITIONS') {
		visibleStep = 'SELECTING_INTERVENTIONS';
		step = <SelectInterventionsStep />;
	} else if (wizardState.currentStep === 'CAPTURE_INTERVENTION_DETAILS') {
		visibleStep = 'CAPTURE_INTERVENTION_DETAILS';
		step = <CaptureInterventionDetailsStep />;
	} else {
		return null;
	}

	return (
		<div
			key={visibleStep}
			ref={node => {
				node?.parentElement?.scrollTo({ top: 0 });
			}}
		>
			{step}
		</div>
	);
}
